import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";

import HNSColors from "../../../../../../ui library/HNSColors";

const AccordionContainer = ({
  title,
  icon,
  children,
  defaultExpanded = true,
  id,
  accordionDetailsSx = {},
}) => {
  return (
    <Accordion
      className="w-full !rounded-xl !border-none bg-white p-2 !shadow-none"
      defaultExpanded={defaultExpanded}
      sx={{
        "&::before": {
          display: "none !important",
        },
        margin: 0,
        "&.Mui-expanded": {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ fontSize: 32, color: HNSColors.primary[500] }} />}
      >
        <Box display="flex" alignItems="center" gap={1}>
          {icon}
          {typeof title === "string" ? (
            <Typography className="text-lg font-semibold" variant="h2">
              {title}
            </Typography>
          ) : (
            title
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails
        id={id}
        sx={accordionDetailsSx}
        className="h-auto max-h-[450px] overflow-y-auto"
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionContainer;
